import katex from 'katex';

window.renderKatexAndReturnElement = function(string) {
    const target = document.createElement('div');
    target.style = 'display: flex; flex-direction: row'

    let pointer = 0
    let latexExpression = false
    let currentString = ''

    function appendToTarget(string) {
        let div = document.createElement('div')
        div.innerText = string

        target.append(div)
    }

    while(pointer < string.length) {
        if(!latexExpression) {
            const tag = string.substring(pointer, pointer + 7)
            if(tag === '<latex>') {
                // we found latex
                appendToTarget(currentString)
                pointer += 6
                latexExpression = true
                currentString = ''
            } else {
                currentString += string[pointer]
            }
        } else {
            const tag = string.substring(pointer, pointer + 8)

            if(tag == '</latex>') {
                let element1 = document.createElement('div')
                element1.style = 'margin-left: 4px; margin-right: 4px;'
                katex.render(currentString, element1, {
                    throwOnError: false
                });

                latexExpression = false
                currentString = ''

                pointer += 8
                target.append(element1)

            } else {
                currentString += string[pointer]
            }
            // console.log(tag)
        }

        pointer++

    }

    appendToTarget(currentString)

    return target;
}

window.renderKatex = function(string, targetId) {
    const target = window.renderKatexAndReturnElement(string)
    target.id = targetId

    document.getElementById(targetId).replaceWith(target)
}


window.parseKatexText = function (){
    if(document.getElementsByClassName('latex-content')) {

        let elements = document.getElementsByClassName('latex-content')
        while(elements.length > 0) {
            if(!elements[0].id) {
                elements[0].id = `super_random_string_${Math.random()}`;
            }

            window.renderKatex(elements[0].textContent, elements[0].id)
            elements = document.getElementsByClassName('latex-content')
        }
    }
}

window.parseKatexText()



